import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const item = css`
  padding-inline-end: ${spacing(0.5)}; // 4px
  padding-block-end: ${spacing(0.5)}; // 4px
`
export const skeleton = css`
  block-size: ${spacing(12.25)}; // 98px
  inline-size: 100%;
`
